
export const GRID_SIZE = 32;
export const CELL_SIZE = 25;

